import ToggleSwitch from './ToggleSwitch.jsx';
import ToggleSwitchWithLabel from './ToggleSwitchWithLabel.jsx';

export {
    ToggleSwitchWithLabel
};

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/ToggleSwitch/index.js